<div class="container-lista-exposicoes">
  <button *ngFor="let item of exposicoes" (click)="selecionarExposicao(item)">
    <ion-icon [name]="item.procedimento"></ion-icon>
    <div class="conteudo">
      <span class="procedimento">{{ manejosDisponiveis[item.procedimento].nome }}</span>
      <span class="data">{{ item.data | timestamp: 'data' }} - {{ item.diff }} dias atrás</span>
    </div>
  </button>
</div>
